// Static product catalog grouped by category. Each product has a stable `id`
// to be used as React key (avoids index-based keys).

const ASSET_BASE = "https://customer-assets.emergentagent.com/job_electric-essentials/artifacts";

export const productCatalog = [
  {
    id: "wires-and-cables",
    title: "Wires & Cables",
    subCategories: [
      {
        id: "copper-range",
        title: "Copper Range",
        products: [
          {
            id: "multistrand-onyx",
            name: "MULTISTRAND (ONYX SERIES)",
            image: `${ASSET_BASE}/1plqevij_1.png`,
          },
          {
            id: "multicore-round-pvc",
            name: "MULTICORE ROUND PVC INSULATED COPPER CONDUCTOR INDUSTRIAL CABLE",
            image: `${ASSET_BASE}/fo5k1xip_Screenshot_20251125_040153_Drive.png`,
          },
          {
            id: "twin-twisted-copper",
            name: "PVC INSULATED FLEXIBLE TWIN TWISTED COPPER CABLES",
            image: `${ASSET_BASE}/b3xnrx56_Screenshot_20251125_040616_Drive.png`,
          },
          {
            id: "cotton-wires",
            name: "COTTON WIRES",
            image: `${ASSET_BASE}/htnmvv6k_Screenshot_20251125_040813_Drive.png`,
          },
        ],
      },
      {
        id: "aluminium-range",
        title: "Aluminium Range",
        products: [],
        placeholder: "Product images will be added here",
      },
    ],
  },
  {
    id: "switchgears-distribution-boards",
    title: "Switchgears & Distribution Boards",
    products: [
      {
        id: "automatic-changeover-32a-dp",
        name: "AUTOMATIC CHANGEOVER 32Amp DP",
        image: `${ASSET_BASE}/j3vycyqd_3.png`,
      },
      {
        id: "manual-changeovers-range",
        name: "Range of Manual CHANGEOVERS (16Amp DP, 32Amp DP, 63Amp DP, 63Amp FP, 100Amp FP)",
        image: `${ASSET_BASE}/cnz2fkqj_4.png`,
      },
      {
        id: "distribution-boards-mcb",
        name: "DISTRIBUTION BOARDS (MCB BOXES)",
        image: `${ASSET_BASE}/2dxke22k_10.png`,
      },
    ],
  },
  {
    id: "tops-multiplugs-accessories",
    title: "Tops, Multiplugs & other Accessories",
    products: [
      {
        id: "combined-box-16a-2-2",
        name: "COMBINED BOX TYPE 16Amp (2+2)",
        image: `${ASSET_BASE}/yc3kigyj_5.png`,
      },
      {
        id: "bed-switch",
        name: "BED SWITCH",
        image: `${ASSET_BASE}/fwq73d4k_6.png`,
      },
      {
        id: "combined-box-16a",
        name: "COMBINED BOX TYPE 16Amp",
        image: `${ASSET_BASE}/el71utwr_7.png`,
      },
      {
        id: "pvc-insulated-tape",
        name: "PVC INSULATED TAPE",
        image: `${ASSET_BASE}/d1x43pfa_9.png`,
      },
      {
        id: "multiplug-6a",
        name: "MULTIPLUG 6Amp",
        image: `${ASSET_BASE}/08dxk35w_11.png`,
      },
      {
        id: "3-pin-top-stallion",
        name: "3 PIN TOP STALLION",
        image: `${ASSET_BASE}/4y9k3iti_12.png`,
      },
      {
        id: "3-pin-top-yuria",
        name: "3 PIN TOP YURIA",
        image: `${ASSET_BASE}/ukij2sbx_13.png`,
      },
      {
        id: "batten-holder-onyx",
        name: "BATTEN HOLDER ONYX",
        image: `${ASSET_BASE}/04hldzah_14.png`,
      },
    ],
  },
  {
    id: "appliances",
    title: "Appliances",
    products: [
      {
        id: "blower-stallion",
        name: "BLOWER STALLION",
        image: `${ASSET_BASE}/2dfeyizu_2.png`,
      },
      {
        id: "immersion-rod-waterproof",
        name: "IMMERSION ROD (WATER PROOF)",
        image: `${ASSET_BASE}/yf7g5xpr_8.png`,
      },
      {
        id: "blower-onyx",
        name: "BLOWER ONYX",
        image: `${ASSET_BASE}/uopx5q4d_15.png`,
      },
    ],
  },
];

export const featureIconMap = {
  "premium-quality": "Shield",
  "safety-certified": "Award",
  "wide-range": "Cable",
  "expert-support": "Zap",
};
